import React, { FunctionComponent } from 'react';

export const SwimIcon: FunctionComponent = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6177 6.02863L11.6186 6.02735C9.37864 4.43639 6.42215 4.38776 4.23774 5.97851C3.8456 6.20521 3.66541 6.82283 3.94527 7.16363C4.22534 7.56137 4.72933 7.61809 5.12147 7.39075C6.80083 6.19817 9.04012 6.19775 10.7199 7.38905L10.7191 7.39075C12.9592 8.98129 15.9155 9.03034 18.0994 7.43959C18.4918 7.21268 18.6722 6.59527 18.3928 6.25448C18.1123 5.85674 17.6085 5.79979 17.2159 6.02756C15.5368 7.2195 13.2977 7.21993 11.6177 6.02863"
        fill="#979797"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6177 11.5336L11.6186 11.5324C9.37864 9.94139 6.42215 9.89277 4.23774 11.4835C3.8456 11.7102 3.66541 12.3276 3.94527 12.6684C4.22534 13.0662 4.72933 13.1231 5.12147 12.8955C6.80083 11.703 9.04012 11.7025 10.7199 12.8938L10.7191 12.8955C12.9592 14.4861 15.9155 14.5351 18.0994 12.9444C18.4918 12.7175 18.6722 12.1001 18.3928 11.7593C18.1123 11.3615 17.6085 11.3046 17.2159 11.5324C15.5368 12.7245 13.2977 12.7249 11.6177 11.5336"
        fill="#979797"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6177 17.0388L11.6186 17.0373C9.37864 15.4461 6.42215 15.3979 4.23774 16.9886C3.8456 17.2149 3.66541 17.8327 3.94527 18.1733C4.22534 18.5713 4.72933 18.628 5.12147 18.4007C6.80083 17.2081 9.04012 17.2077 10.7199 18.399L10.7191 18.4007C12.9592 19.9912 15.9155 20.04 18.0994 18.4493C18.4918 18.2226 18.6722 17.6048 18.3928 17.2642C18.1123 16.8662 17.6085 16.8095 17.2159 17.0373C15.5368 18.2296 13.2977 18.2301 11.6177 17.0388"
        fill="#979797"
      />
    </svg>
  );
};
